import type { ReactNode } from "react";
import { createContext, useContext } from "react";

const PortalScopeContext = createContext<HTMLElement | null | undefined>(
  undefined,
);

interface Props {
  container: HTMLElement | null;
  children: ReactNode;
}

export function usePortalScope() {
  return useContext(PortalScopeContext);
}

function DPortalScopeProvider({ container, children }: Props) {
  return (
    <PortalScopeContext.Provider value={container}>
      {children}
    </PortalScopeContext.Provider>
  );
}

export default DPortalScopeProvider;
